import { useMemo } from "react"
import { debounce } from "../services/utils/lodash.service"

export function useDebouncer (interval: number) {
  return useMemo(() => debounce((fn: () => void) => fn(), interval), [interval])
}
